import * as React from 'react';
import autobind from 'autobind-decorator';

// interfaces
import { ILearningElement } from 'store/StateInterfaces';

//assets
import '../Assets/content_developer.sass';

import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import DescriptionIcon from '@material-ui/icons/Description';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import { IconButton } from '@material-ui/core';
import { Row, Col, ListGroup, Container, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'
import { DropdownButton, Dropdown } from 'react-bootstrap';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import AddElementForm from './AddElementForm';

// dragula for reordering
import * as dragula from 'dragula';
import 'dragula/dist/dragula.css';

interface IProps {
  playlist: Array<ILearningElement>;
  onSelectCallback: any;
  onAddCallback: any;
  onDeleteCallback: any;
  onReorderCallback: any;
  onPublishCallback: any;
}

interface IState {
  add: boolean;
  order: boolean;
  type: string;
}

export default class LearningElementsList extends React.Component<IProps, IState> {

  private dragulaService: any;
  private playlistCopy: any;
  private id2playlist: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      add: false,
      order: false,
      type: undefined,
    }
  }

  @autobind
  toggleAdd() {
    this.setState((state) => {
      return {
        ...state,
        add: !state.add
      }
    })
  }

  @autobind
  toggleOrder() {
    if (this.state.order) {
      // save order here 
      this.dragulaService.destroy()
      let type2int = { 'video': 0, 'quiz': 1, 'document': 2 };
      console.log('playlistcopy', this.playlistCopy);
      const playlistPayload = this.playlistCopy.map((p) => {
        return [p.content.id, type2int[p.type]]
      })
      console.log('payload ',playlistPayload)
      this.props.onReorderCallback(playlistPayload);
      this.setState({ order: false })
    }
    else {
      // set up dragula service
      this.playlistCopy = this.props.playlist.map(e => ({ ...e }));
      this.id2playlist = {};
      this.playlistCopy.forEach((p) => {
        this.id2playlist[`${p.type}-${p.content.id}`] = p;
      })

      this.dragulaService = dragula([document.getElementById(`playlistContainer`)], {
        revertOnSpill: true,
        moves: function (el, container, handle) {
          console.log(handle);
          return handle.classList.contains(`playlistHandle`);
        }
      }).on('drop', function (el, container, handle) {
        console.log('element', el);
        console.log('container', container);
        console.log('handle', handle);
        this.playlistCopy = Array.from(container.children).map(function (p) {
          return this.id2playlist[p["id"]]
        }.bind(this))
      }.bind(this));


      this.setState({ order: true })
    }

  }

  @autobind
  handleTypeSelect(eventKey, event) {
    this.setState({
      type: eventKey,
      add: true
    })
  }


  public capitaliseFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  @autobind
  public onSave(type: string, formData: FormData) {
    this.props.onAddCallback(type, formData)
    this.toggleAdd();
  }

  public render() {
    let id = { 'video': 0, 'quiz': 1, 'document': 2 };
    let elementList = this.props.playlist.map((item, i) => {
      return (
        <Row key={`${item.type}-${item.content.id}`}
          id={`${item.type}-${item.content.id}`} className="border no-gutters">

          {/* icon */}
          <Col style={{ marginLeft: '4%' }} xs={{ span: 1 }}>
            {!this.state.order ?
              (item.type == "video" ? <PlayCircleFilledIcon fontSize="large" color="primary" /> :
                item.type == "quiz" ? <ContactSupportIcon fontSize="large" color="primary" /> :
                  <DescriptionIcon fontSize="large" color="primary" />)
              :
              (
                <span className={`playlistHandle`}>
                  #
                </span>
              )
            }
          </Col>

          {/* selector text */}
          <Col xs={{ span: 7 }}>
            <Button variant="link" onClick={() => this.props.onSelectCallback(i)}>
              {item.content.title + " (" + this.capitaliseFirstLetter(item.type) + ")"}
            </Button>
          </Col>

          {/* publish button */}
          <Col xs={{ span: 2 }}>
            Published:
            <Switch
              edge="end"
            />
          </Col>

          {/* delete button */}
          <Col style={{ marginLeft: '4%' }} xs={{ span: 1 }}>
            <IconButton
              edge="end"
              onClick={() => {
                this.props.onDeleteCallback(item.type, id[item.type], item.content.id)
              }}
              aria-label="delete"
            >
              <DeleteIcon />
            </IconButton>
          </Col>


        </Row >
      );
    });

    return (
      <React.Fragment>
        {
          this.state.add ?
            (
              <Modal show={this.state.add} onHide={this.toggleAdd}>
                <Modal.Header closeButton>
                  <Modal.Title>{`Add ${this.state.type}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <AddElementForm
                    cancelCallback={this.toggleAdd}
                    saveCallback={this.onSave}
                    type={this.state.type}
                  />
                </Modal.Body>
              </Modal>
            )
            :
            (
              <React.Fragment>

                {/* control buttons */}
                <div className="control-buttons">
                  <DropdownButton
                    drop="right"
                    variant="light"
                    title={<span><AddCircleOutlineOutlinedIcon fontSize="small" /> Add Content</span>}
                    id={`dropdown-button-drop-right`}
                    onSelect={this.handleTypeSelect}
                  >
                    <Dropdown.Item eventKey="document">Document</Dropdown.Item>
                    <Dropdown.Item eventKey="video">Video</Dropdown.Item>
                    <Dropdown.Item eventKey="quiz">Quiz</Dropdown.Item>
                  </DropdownButton>
                  <Button
                    onClick={this.toggleOrder}
                    variant="light"
                  >
                    <span><ImportExportIcon fontSize="small" />
                      {this.state.order ? 'Save Order' : 'Reorder'}
                    </span>
                  </Button>
                </div>


                <br />

                {/* list of elements */}
                <div id='playlistContainer'>
                  {elementList}
                </div>

              </React.Fragment>
            )
        }
      </React.Fragment >
    );
  }
}
